var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Help_Icon",
    "data-name": "Help Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.784,
    height: 28.784,
    viewBox: "0 0 28.784 28.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Help_Icon-2",
    "data-name": "Help Icon",
    d: "M14.392,0A14.392,14.392,0,1,0,28.784,14.392,14.434,14.434,0,0,0,14.392,0Zm-.144,23.891a2.015,2.015,0,1,1,2.015-2.015A1.968,1.968,0,0,1,14.248,23.891Zm3.886-11.226-1.583,1.727a1.758,1.758,0,0,0-.576,1.3,1.75,1.75,0,0,1-1.727,1.727,1.663,1.663,0,0,1-1.727-1.727A3.212,3.212,0,0,1,13.672,13.1l1.3-1.583A3.267,3.267,0,0,0,15.975,9.5a1.51,1.51,0,0,0-1.583-1.583,1.693,1.693,0,0,0-1.727,1.3,1.879,1.879,0,0,1-1.727,1.007A1.51,1.51,0,0,1,9.355,8.635a1.565,1.565,0,0,1,.144-.72c.576-1.727,2.3-3.022,4.893-3.022,3.022,0,5.037,2.015,5.037,4.605A4.722,4.722,0,0,1,18.134,12.665Z",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/Help Icon.b453c9427ab0038a4c833a2d33f100db.svg";
export { ForwardRef as ReactComponent };